import { TaskQueryParams } from '@ml/tasks/types/classes/task-query-params.class';
var TaskFilters = /** @class */ (function () {
    function TaskFilters(taskFilters) {
        Object.assign(this, taskFilters);
    }
    Object.defineProperty(TaskFilters.prototype, "empty", {
        get: function () {
            return !this.employee && !(this.status && this.status.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskFilters.prototype, "queryParams", {
        get: function () {
            var params = new TaskQueryParams();
            if (this.status) {
                params.status = this.status ? this.status.join(',') : '';
            }
            if (this.employee) {
                params.employee = this.employee;
            }
            return params;
        },
        enumerable: true,
        configurable: true
    });
    TaskFilters.fromParams = function (params) {
        var taskFilter = new TaskFilters();
        if (params.status) {
            taskFilter.status =
                typeof params.status === 'string' ? [params.status] : params.status;
        }
        if (params.employee) {
            taskFilter.employee = +params.employee;
        }
        return taskFilter;
    };
    Object.defineProperty(TaskFilters.prototype, "params", {
        get: function () {
            var filterParams = {};
            if (this.status) {
                filterParams.status = this.status;
            }
            if (this.employee) {
                filterParams.employee = this.employee;
            }
            return filterParams;
        },
        enumerable: true,
        configurable: true
    });
    return TaskFilters;
}());
export { TaskFilters };
